export default __webpack_public_path__ + "static/1-43514ebdf0c00581b7f444efdcec9e1a.jpeg";